export default __webpack_public_path__ + "static/media/Sirar.09966cfa.jpg";